import { ValidatePaymentFormError } from 'src/pages/payment-msi/PaymentMsiV2/utils';

export const scrollToFirstError = (formErrors: ValidatePaymentFormError[]) => {
  const firstError = formErrors[0];

  if (!firstError) {
    return;
  }

  const element = document.querySelector(`[name="${firstError.fieldName}"]`);

  if (!element) {
    return;
  }

  const topOffset = element.getBoundingClientRect().x;

  window.scrollTo({
    top: topOffset,
    behavior: 'smooth',
  });
};
